export const buildFormData = (formData, data, parentKey) => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(
                formData,
                data[key],
                parentKey
                    ? `${parentKey}[${key}]`
                    : key
            );
        });
    } else if (data !== undefined && data !== '' && data !== null) {
        formData.append(parentKey, data);
    }
}

export const updateNestedObjectValue = (obj, name, value) => {
    if (name.includes('[')) {
        name = name.replaceAll('[', '.');
    }
    if (name.includes(']')) {
        name = name.replaceAll(']', '');
    }

    let current = obj;
    const filedNameParts = name.split('.');
    for (let i = 0; i < filedNameParts.length - 1; i++) {
        if (!current[filedNameParts[i]]) {
            current[filedNameParts[i]] = {};
        }
        current = current[filedNameParts[i]];
    }
    current[filedNameParts[filedNameParts.length - 1]] = value;
}

export const parseDateFromString = (dateString, removeTimePart = false, defaultValue = null) => {
    
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
        // remove time part
        if(removeTimePart === true){
        date.setHours(0, 0, 0, 0);
        }
        return date;
    }
    return defaultValue;
}